export class Mask {
  
  constructor() {
    this.identificationField = $('#identification')
    this.documentCpf = $("#document__cpf")
    this.documentCnpj = $("#document__cnpj")
  }

  applyMaskListener(element, document='cpf') {
    element
      .attr('placeholder', `Informe aqui o seu ${document.toUpperCase()}`)
      .mask(() => {
        if (document == 'cpf') return '000.000.000-00'
        if (document == 'cnpj') return '00.000.000/0000-00'
      })
  }

  static changeLabelDocumentListener() {
    const mask = new Mask() 
    mask.applyMaskListener(mask.identificationField)

    mask.documentCpf.on('mousedown', () => {
      mask.applyMaskListener(mask.identificationField)
    })

    mask.documentCnpj.on('mousedown', () => {
      mask.applyMaskListener(mask.identificationField, 'cnpj')
    })
  }
}